export const styles = (theme) => ({
  appStoreButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    marginTop: '16px',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      alignItems: 'center',
    },
  },
  appStoreButton: {
    textDecoration: 'none',
  },
  appStoreButtonImage: {
    height: 48,
    width: 'auto',
  },
});
